import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slices/userSlice';
import transectionReducer from "../slices/transectionSlice"
import mediaReducer from "../slices/mediaLogsSlice"
const store = configureStore({
  reducer: {
    users: userReducer,
    transection:transectionReducer,
    media:mediaReducer
  },
   middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // You can tweak options:
      thunk: true,
      serializableCheck: true,
      immutableCheck: true,
    })
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
